import PropTypes from 'prop-types';
import React from 'react';

const OkCancelPopup = ({
  onOk, 
  onCancel, 
  mainText, 
  subText, 
  warningText,
  okText, 
  cancelText,
  messageType,
}) => (
  <div className={`PopupContent__layout ${messageType}`}>
    <div className="PopupContent__text-group">
      <h1>{mainText}</h1>
      <h3>{subText}</h3>
      { warningText && <h3 className="PopupContent__warning">{warningText}</h3> }
    </div>
    <div className="PopupContent__btn-group">
      <button onClick = {() => onOk()}>{okText}</button>
      <button onClick = {() => onCancel()}>{cancelText}</button>
    </div>
  </div>
);

OkCancelPopup.propTypes = {
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  mainText: PropTypes.string,
  subText: PropTypes.string,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
};

export default OkCancelPopup;



// WEBPACK FOOTER //
// ./src/components/OkCancelPopup.js